import { SelectField } from '@eventbrite/eds-input-field';
import { gettext } from '@eventbrite/i18n';
import { trackAnalyticsEvent } from '@eventbrite/site-analytics';
import React, { useMemo } from 'react';
import { ChildEventProps, GACodes, SeriesDatesScopedProps } from '../../types';
import { getFormattedDate } from '../utils/localizedDates';

type SeriesDatesContextType = Array<{
    value: string;
    display: string;
}>;

const trackAnalytics = (action: string) => {
    trackAnalyticsEvent({
        action: action,
        category: GACodes.GA_CATEGORY_LISTING,
        label: GACodes.GA_LABEL_SECONDARY,
    });
};

export const SeriesDatesDropdown = (props: SeriesDatesScopedProps) => {
    const { childEvents, eventId, isOnlineEvent } = props;
    const seriesDates: SeriesDatesContextType = useMemo(
        () =>
            childEvents.map(({ id, start, locale }: ChildEventProps) => ({
                value: id,
                display: getFormattedDate({
                    date: start,
                    format: 'ddd, MMM D (LT)',
                    isOnlineEvent,
                    localizedFormat: 'ddd, MMM D (LT z)',
                    locale,
                }),
            })),
        [childEvents, isOnlineEvent],
    );

    const handleSeriesDropDownOnFocus = () => {
        trackAnalytics(GACodes.GA_ACTION_SELECT_DATE_ATTEMPT);
    };

    const handleSeriesDropDownOnChange = (id: string) => {
        trackAnalytics(GACodes.GA_ACTION_SELECT_DATE);

        window.location.href = window.location.href.replace(eventId, id);
    };

    return (
        <SelectField
            label={gettext('Select a different date')}
            placeholder={gettext('Select a different date')}
            values={seriesDates}
            onChange={handleSeriesDropDownOnChange}
            onFocus={handleSeriesDropDownOnFocus}
            style={'basic'}
        />
    );
};

export default SeriesDatesDropdown;
